/* eslint-disable */
// import Swiper from "swiper/bundle";
// import { transform } from "lodash-es";
import Swiper from "swiper";

/* eslint-enable */

class LandHeroHomeSwiper {
	
	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$landHeroSection = this.sectionsContainer.querySelector('.land-hero-home-swiper');
		
		if (!this.$landHeroSection)
			return;
		
		this.sliderHeroSections = this.sectionsContainer.getElementsByClassName("land-hero-home-swiper");
		this.$landHeroSectionElements = this.$landHeroSection.querySelectorAll('.anima');
		this.$landHeroSectionSlides = this.$landHeroSection.querySelectorAll('.swiper-slide');
		console.log(this.$landHeroSectionSlides)
		this.$landHeroSectionImage = this.$landHeroSection.querySelectorAll('.content-image-slide .image');

		// 🔹 Inicializar swiperInstances como array vacío para evitar errores
		this.swiperInstances = [];

		if (this.sliderHeroSections[0]) {
			this.init();
		}

		this.setAnimation();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		Array.from(this.sliderHeroSections).forEach((section) =>
			this.initializeSwiper(section)
		);
	}

	setAnimation() {
        gsap.set(this.$landHeroSectionElements, { yPercent: 20, opacity: 0.0001 });
		gsap.set(this.$landHeroSectionImage, {
			xPercent: 2, opacity: 0.0001, onComplete: () => {
				this.initAnimate();
		} });		
	}

	initAnimate() {
		this.animateHero = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$landHeroSection,
                start: 'top center',
			},
			onComplete: () => {
				gsap.set(this.$landHeroSectionElements, { clearProps: true });
				gsap.set(this.$landHeroSectionImage, { clearProps: true });
			}
        });
    
        this.animateHero.addLabel('step1');
        this.animateHero.to(this.$landHeroSection, { opacity: 1}, 'step1');
        this.animateHero.to(this.$landHeroSectionImage, { xPercent: 0, opacity: 1 }, 'step1+=0.3');
		this.animateHero.to(this.$landHeroSectionElements, { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	
	initializeSwiper() {
		// console.log(this.sliderGallerySections);
		if (!this.sliderHeroSections) {
			return;
		}

		Array.from(this.sliderHeroSections).forEach((section) => {
			const swiperContainer = section.querySelector('.swiper-container');
			const swiperSlides = section.querySelectorAll('.swiper-slide');
			//console.log(section)
			//console.log('.swiper-pagination-land-home');
			//console.log('.swiper-button-next');
			//console.log('.swiper-button-prev');
			
			if (swiperContainer) {
				this.swiperInstances.push(new Swiper(swiperContainer, {
					grabCursor: true,
					loop: false,
					slidesPerView: 1,
					spaceBetween: 0,
					pagination: {
						el: section.querySelector('.swiper-pagination-land-home'),
						clickable: true,
					},
					navigation: {
						nextEl: section.querySelector('.swiper-button-next'),
						prevEl: section.querySelector('.swiper-button-prev'),
						clickable: true,
					}
				}));
			}
		});

		// console.log(this.swiperInstances);
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default LandHeroHomeSwiper;
